import React, { Component } from 'react';
import classNames from 'classnames';

import { BillDownload, BillView, DetailDownload } from '../../images';
import DateFormat from '../../lib/date/DateFormat';
import { Payment } from '../../services';
import { CofirmationPayWindow } from '../../lib/forms';


class InvoiceItem extends Component {
  render() {
    let billsClass = classNames({
      'row': true,
      'row-body': true,
    });
    let {invoice, translate} = this.props
    return (
      <div className={billsClass}  key={invoice.id}>
        <div className="col-1 hidden-md-down">
          <label className="custom-control custom-checkbox">
            <input className="custom-control-input" type="checkbox" /><span className="custom-control-indicator"></span>
          </label>
        </div>
        <div className="col-2 col-md-3 col-lg-2"><small className="hidden-md-up">date: </small><span className="ng-binding"> <DateFormat date={invoice.invoice_date}/></span></div>
        <div className="col-2 col-md-3 push-md-4 col-lg-2 push-lg-4 text-left"><small className="hidden-md-up">montant: </small><span className="ng-binding">{invoice.total_paid_real}</span></div>
        <div className="col-2 col-md-4 pull-md-3 col-lg-4 pull-lg-2 ng-binding">{invoice.invoice_number}</div>
        <div className="col-6 col-md-2 col-lg-3 text-left">
          <span className={`d-inline-block-${invoice.status_color}`}>{invoice.status}</span>
          <a className="d-inline-block" tabIndex="0" data-toggle="tooltip" title="View" href={`${process.env.REACT_APP_BASEURL_INVOICE}${invoice.previewInvoice}`}><img src={BillView} alt="Profile" /></a>     <a className="d-inline-block" tabIndex="0" data-toggle="tooltip" title={translate('download')} href={`${process.env.REACT_APP_BASEURL_INVOICE}${invoice.downloadInvoice}`}><img src={BillDownload} alt="bill-download" /></a>
          <a className="d-inline-block" tabIndex="0" data-toggle="tooltip" title={translate('details')} href={`${process.env.REACT_APP_BASEURL_INVOICE}${invoice.downloadCallDetails}`}><img src={DetailDownload} alt="bill-download" /></a>
          {invoice.warning ? <a className="d-inline-block"  target="_blank"  href={`${invoice.payInvoice}`}>{translate('pay-bill')}</a> : ''}
        </div>
        <CofirmationPayWindow message={translate('pay-now-confirm-message')} invoiceId={invoice.id} invoiceNumber={invoice.invoice_number}/>
      </div>
    )
  }
}
export default InvoiceItem;
// {invoice.payment ? <button className="btn btn-outline-success" type="button" data-target={`.${invoice.id}`} data-toggle="modal"  >{translate('pay-now-button')}</button> : ''}



// WEBPACK FOOTER //
// ./src/components/Invoices/InvoiceItem.js